<script setup>
// PROVISÓRIO (phase 4.2, D-G3 with R2-4-4 → X-4 = B): the "Polaris animation" of the invitation. The kit has the
// field (ArtField) but no animated symbol yet; until it does, this is the Polaris mark floating on the field with a
// halo breathing behind it (keyframes in assets/scss/_polaris-art.scss). Swap it for the kit's piece when it exists.
// Motion stops for whoever prefers less of it (CSS) and while the art is off screen (`data-paused`).
import { ref } from 'vue';
import { useIntersectionObserver } from '@vueuse/core';
import ArtField from './ArtField.vue';
import PolarisMark from 'dashboard/components-next/sidebar/PolarisMark.vue';

defineProps({
  tone: { type: String, default: 'sky' },
});

const root = ref(null);
const visible = ref(true);
useIntersectionObserver(root, ([entry]) => {
  visible.value = entry?.isIntersecting ?? true;
});
</script>

<template>
  <div ref="root" :data-paused="visible ? undefined : ''" data-polaris-art>
    <ArtField :tone="tone" class="size-full">
      <div class="absolute inset-0 grid place-items-center">
        <span
          class="polaris-art-halo absolute size-28 rounded-full bg-polaris-sidebar-primary blur-2xl"
        />
        <span class="polaris-art-mark relative shadow-lg rounded-polaris-lg">
          <PolarisMark size="lg" />
        </span>
      </div>
    </ArtField>
  </div>
</template>
